import withAPIAction from 'helpers/withAPIAction'
import {
  UserListReq,
  MerchantRolesReq,
  CreateUserReq,
  UserDetailReq,
  UpdateUserReq,
  ResetPasswordReq,
  UserStatusReq,
  DeleteUserReq,
} from './types'
import {
  getStaffListAction,
  getMerchantRoleAction,
  createAction,
  getDetailAction,
  updateAction,
  resetPasswordAction,
  updateStatusAction,
  deleteAction,
} from './actions'
import { APIPath } from 'services/APIPath'
import { appConfig } from 'config'
import { getRequestString } from 'helpers/format'

export const userListAPI = (data: UserListReq, token: string, xmid: any) => {
  return withAPIAction<UserListReq>({
    method: 'GET',
    baseUrl: appConfig.backofficeEndpoint,
    path: `${APIPath.getUserList}?${getRequestString(data)}`,
    data,
    token,
    //xmid,
  })(getStaffListAction)
}

export const merchantRoleAPI = (data: MerchantRolesReq, token: string, xmid: any) => {
  return withAPIAction<MerchantRolesReq>({
    method: 'GET',
    baseUrl: appConfig.backofficeEndpoint,
    path: `${APIPath.getMerchantRoleList}?${getRequestString(data)}`,
    data,
    token,
    //xmid,
  })(getMerchantRoleAction)
}

export const merchantCreateUserAPI = (data: CreateUserReq, token: string, xmid: any) => {
  return withAPIAction<CreateUserReq>({
    method: 'POST',
    baseUrl: appConfig.backofficeEndpoint,
    path: APIPath.merchantCreateUserStaff,
    data,
    token,
    //xmid,
  })(createAction)
}

export const userDetailAPI = (data: UserDetailReq, token: string, xmid: any) => {
  const endPoint = APIPath.merchantUserByID.replace(':id', data.id.toString())
  return withAPIAction<UserDetailReq>({
    method: 'GET',
    baseUrl: appConfig.backofficeEndpoint,
    path: endPoint,
    data,
    token,
    // xmid,
  })(getDetailAction)
}

export const updateUserAPI = (data: UpdateUserReq, token: string, xmid: any) => {
  const endPoint = APIPath.merchantUpdateUserStaff.replace(':id', data.id.toString())
  return withAPIAction<UpdateUserReq>({
    method: 'PUT',
    baseUrl: appConfig.backofficeEndpoint,
    path: endPoint,
    data,
    token,
    //xmid,
  })(updateAction)
}

export const resetUserPasswordAPI = (data: ResetPasswordReq, token: string, xmid: any) => {
  const endPoint = APIPath.merchantResetStaffPin.replace(':id', data.id.toString())
  return withAPIAction<ResetPasswordReq>({
    method: 'PUT',
    baseUrl: appConfig.backofficeEndpoint,
    path: endPoint,
    data,
    token,
    //xmid,
  })(resetPasswordAction)
}

export const updateUserStatusAPI = (data: UserStatusReq, token: string, xmid: any) => {
  const endPoint = APIPath.merchantUpdateUserStaus.replace(':id', data.id.toString())
  return withAPIAction<UserStatusReq>({
    method: 'PUT',
    baseUrl: appConfig.backofficeEndpoint,
    path: endPoint,
    data,
    token,
  })(updateStatusAction)
}

export const deleteUserAPI = (data: DeleteUserReq, token: string, xmid: any) => {
  const endPoint = APIPath.merchantDeleteUser.replace(':id', data.id.toString())
  return withAPIAction<DeleteUserReq>({
    method: 'DELETE',
    baseUrl: appConfig.backofficeEndpoint,
    path: endPoint,
    data,
    token,
    xmid,
  })(deleteAction)
}

// export const getRolesAPI = (data: StaffRolesReq, token: string, xmid: any) => {
//   return withAPIAction<StaffRolesReq>({
//     method: 'GET',
//     baseUrl: appConfig.backofficeEndpoint,
//     path: APIPath.posGetStaffRoles,
//     data,
//     token,
//     xmid,
//   })(getRolesListAction)
// }

// export const updateStaffAPI = (data: UpdateStaffReq, token: string, xmid: any) => {
//   const endPoint = APIPath.posUpdateStaff.replace(':id', data.id.toString())
//   return withAPIAction<UpdateStaffReq>({
//     method: 'PUT',
//     baseUrl: appConfig.backofficeEndpoint,
//     path: endPoint,
//     data,
//     token,
//     xmid,
//   })(updateAction)
// }

// export const deleteStaffAPI = (data: DeleteStaffReq, token: string, xmid: any) => {
//   const endPoint = APIPath.posDeleteStaff.replace(':id', data.id.toString())
//   return withAPIAction<DeleteStaffReq>({
//     method: 'DELETE',
//     baseUrl: appConfig.backofficeEndpoint,
//     path: endPoint,
//     data,
//     token,
//     xmid,
//   })(deleteAction)
// }

// export const updateStaffStatusAPI = (data: StaffStatusReq, token: string, xmid: any) => {
//   const endPoint = APIPath.posUpdateStaffStaus.replace(':id', data.id.toString())
//   return withAPIAction<StaffStatusReq>({
//     method: 'PUT',
//     baseUrl: appConfig.backofficeEndpoint,
//     path: endPoint,
//     data,
//     token,
//     xmid,
//   })(updateStaffStatusAction)
// }

// export const resetStaffPinAPI = (data: ResetPinReq, token: string, xmid: any) => {
//   const endPoint = APIPath.posResetStaffPin.replace(':id', data.id.toString())
//   return withAPIAction<ResetPinReq>({
//     method: 'PUT',
//     baseUrl: appConfig.backofficeEndpoint,
//     path: endPoint,
//     data,
//     token,
//     xmid,
//   })(resetPinAction)
// }

// export const getMerchantPackageListAPI = (data: MerchantPackageListReq, token: string, xmid: any) => {
//   return withAPIAction<MerchantPackageListReq>({
//     method: 'GET',
//     baseUrl: appConfig.backofficeEndpoint,
//     path: APIPath.posMerchantPackageList,
//     data,
//     token,
//     xmid,
//   })(getMerchantPackageListAction)
// }

// export const getPackagesSpecAPI = (data: PackagesSpecReq, token: string, xmid: any) => {
//   return withAPIAction<PackagesSpecReq>({
//     method: 'GET',
//     baseUrl: appConfig.backofficeEndpoint,
//     path: APIPath.posPackageSpec,
//     data,
//     token,
//     xmid,
//   })(getPackagesSpecAction)
// }

// export const packageSpecByIDAPI = (data: PackagesSpecByIDReq, token: string, xmid: any) => {
//   const endPoint = APIPath.posPackageSpecByID.replace(':id', data.id.toString())
//   return withAPIAction<PackagesSpecByIDReq>({
//     method: 'GET',
//     baseUrl: appConfig.backofficeEndpoint,
//     path: endPoint,
//     data,
//     token,
//     xmid,
//   })(getPackagesSpecByIDAction)
// }

// export const buyPackageAPI = (data: PackagesRegisReq, token: string, xmid: any) => {
//   return withAPIAction<PackagesRegisReq>({
//     method: 'POST',
//     baseUrl: appConfig.backofficeEndpoint,
//     path: APIPath.posBuyPackage,
//     data,
//     token,
//     xmid,
//   })(buyPackageAction)
// }

// export const renewPackageAPI = (data: PackagesRegisReq, token: string, xmid: any) => {
//   return withAPIAction<PackagesRegisReq>({
//     method: 'POST',
//     baseUrl: appConfig.backofficeEndpoint,
//     path: APIPath.posRenewPackage,
//     data,
//     token,
//     xmid,
//   })(renewPackageAction)
// }

// export const activatePackageAPI = (data: ActivateReq, token: string, xmid: any) => {
//   const endPoint = APIPath.posActivatePackage.replace(':id', data.id.toString())
//   return withAPIAction<ActivateReq>({
//     method: 'PUT',
//     baseUrl: appConfig.backofficeEndpoint,
//     path: endPoint,
//     data,
//     token,
//     xmid,
//   })(activatePackageAction)
// }

// export const getPackageLogsAPI = (data: PackageLogReq, token: string, xmid: any) => {
//   const endPoint = APIPath.posPackageLog.replace(':id', data.id.toString())
//   return withAPIAction<PackageLogReq>({
//     method: 'GET',
//     baseUrl: appConfig.backofficeEndpoint,
//     path: `${endPoint}?${getRequestString(data)}`,
//     data,
//     token,
//     xmid,
//   })(getPackagesLogAction)
// }
